import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';
import { posts } from '../data/posts';
import { useLanguage } from '../lib/LanguageContext';

const JournalPage = () => {
  const { language } = useLanguage();
  const ro = language === 'ro';

  useEffect(() => {
    const previous = document.title;
    document.title = `${ro ? 'News și Jurnal' : 'News & Journal'} — DIMIRXSON`;
    return () => { document.title = previous; };
  }, [ro]);

  return <div className="min-h-screen bg-bone text-charcoal" data-testid="journal-page">
    <Header />
    <main className="px-6 pb-24 pt-32 md:px-12 md:pb-32 md:pt-40 lg:px-16">
      <Reveal>
        <span className="text-[11px] uppercase tracking-eyebrow text-charcoal/55">DIMIRXSON · Editorial</span>
        <h1 className="mt-6 max-w-6xl font-sans text-6xl font-extrabold leading-[0.9] sm:text-7xl lg:text-[8vw]">
          {ro ? 'News și Jurnal' : 'News & Journal'}
        </h1>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-16 border-t border-charcoal pt-10 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post, index) => {
          const content = post[language] || post.en;
          return <Reveal key={post.slug} delay={(index % 3) * 0.06}>
            <Link to={`/journal/${post.slug}`} className="group block">
              <div className="relative aspect-[5/4] overflow-hidden bg-beige">
                <img src={post.cover} alt={content.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
              </div>
              <div className="mt-5 flex justify-between text-[10px] uppercase tracking-eyebrow text-charcoal/55">
                <span>{post.type}</span><time dateTime={post.isoDate}>{post.date[language]}</time>
              </div>
              <h2 className="mt-4 font-sans text-3xl font-extrabold leading-[1.02] group-hover:opacity-65 md:text-4xl">{content.title}</h2>
              <p className="mt-4 text-base leading-relaxed text-charcoal/70">{content.excerpt}</p>
            </Link>
          </Reveal>;
        })}
      </div>
    </main>
    <Footer />
  </div>;
};

export default JournalPage;
